(function () {
  const STORAGE_KEY = "uniq_recently_viewed";
  const MAX_STORE = 24;

  function getList() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
    } catch (e) {
      return [];
    }
  }

  async function fetchProductCardHTML(handle, sectionId) {
    // Uses Shopify’s Section Rendering API to render a product card via a helper section (below)
    const url = `${window.Shopify.routes.root}?section_id=recently-viewed-card&product=${encodeURIComponent(handle)}&sid=${encodeURIComponent(sectionId)}`;
    const res = await fetch(url, { credentials: "same-origin" });
    if (!res.ok) return "";
    return await res.text();
  }

  async function init() {
    const section = document.querySelector(".recently-viewed[data-section-id]");
    if (!section) return;

    const sectionId = section.getAttribute("data-section-id");
    const limit = parseInt(section.getAttribute("data-limit") || "6", 10);

    const list = getList();
    if (!list.length) {
      section.style.display = "none";
      return;
    }

    const ul = section.querySelector("ul.product-grid");
    if (!ul) return;

    // Show most recent first
    const handles = list.slice(0, MAX_STORE).slice(0, limit);

    const htmlChunks = [];
    for (const handle of handles) {
      const html = await fetchProductCardHTML(handle, sectionId);
      if (html) htmlChunks.push(html);
    }

    if (!htmlChunks.length) {
      section.style.display = "none";
      return;
    }

    ul.innerHTML = htmlChunks.join("");
  }

  document.addEventListener("DOMContentLoaded", init);
})();
